import * as Yup from "yup";
import { validateAFM } from "../../utils/greekVatValidation";

const noSpaceRegExp = /^\S+$/;

Yup.addMethod(Yup.string, "vatGreek", function (message) {
  return this.test("test-vat-greek", message, function (value) {
    const { path, createError } = this;

    if (validateAFM(value)) {
      return true;
    } else {
      return createError({ path, message });
    }
  });
});

export const yupPassword = (t) =>
  Yup.string()
    .min(10, t("Register.PasswordLengthError", { min: 10 }))
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*_\-~+=.,?]).*$/,
      t("Register.PasswordErrorCharacters")
    )
    .matches(noSpaceRegExp, t("Register.ErrorNoSpaces"))
    .required(t("Register.PasswordError"));

export const yupRepeatPassword = (t) =>
  Yup.string()
    .oneOf([Yup.ref("password"), null], t("Register.RepeatPasswordError"))
    .required(t("Register.RepeatPasswordError"));

export const yupTaxNumber = (t) =>
  Yup.string().vatGreek(t("Register.ErrorVat")).nullable();

/********* Rich Text Editor **********/

Yup.addMethod(Yup.object, "richText", function (message) {
  return this.test("test-rich-text", message, function (value) {
    const { path, createError } = this;

    const editorState = value;

    if (!editorState) {
      return createError({ path, message });
    }

    const editorContent = editorState.getCurrentContent();
    const text = editorContent.getPlainText();

    if (!text?.length) {
      return createError({ path, message });
    }

    return true;
  });
});

Yup.addMethod(Yup.object, "richLength", function (max, message) {
  return this.test("test-rich-text-length", message, function (value) {
    const { path, createError } = this;

    const editorState = value;

    if (!editorState) {
      return true;
    }

    const editorContent = editorState.getCurrentContent();
    const text = editorContent.getPlainText();

    if (text?.length && text.length > max) {
      return createError({ path, message });
    }

    return true;
  });
});

export const yupRichText = (max, message) =>
  Yup.object().richText(max, message);
